/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MenuItem,
    MenuItemFromJSON,
    MenuItemFromJSONTyped,
    MenuItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MenuItemDataFrame
 */
export interface MenuItemDataFrame {
    /**
     * 
     * @type {number}
     * @memberof MenuItemDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof MenuItemDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof MenuItemDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<MenuItem>}
     * @memberof MenuItemDataFrame
     */
    data: Array<MenuItem>;
}

export function MenuItemDataFrameFromJSON(json: any): MenuItemDataFrame {
    return MenuItemDataFrameFromJSONTyped(json, false);
}

export function MenuItemDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuItemDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(MenuItemFromJSON)),
    };
}

export function MenuItemDataFrameToJSON(value?: MenuItemDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(MenuItemToJSON)),
    };
}


